import { IconSquare, IconSquareCheckFilled } from '@tabler/icons-react';
import type { ProcedureStepCheckView } from '@actschurch/ccms-sdk';

/**
 * The small checks inside a step ("Light is green", "Fader at zero"), as big tappable rows
 * (at least 56 px) with checkbox semantics.
 */
export function StepChecks({
  checks,
  checked,
  onToggle,
  disabled,
}: {
  checks: ProcedureStepCheckView[];
  checked: number[];
  onToggle: (checkId: number) => void;
  disabled?: boolean;
}) {
  if (!checks.length) return null;
  const sorted = [...checks].sort((a, b) => a.sortOrder - b.sortOrder);
  const done = sorted.filter((c) => checked.includes(c.checkID)).length;
  return (
    <section className="proc-checks" aria-labelledby="proc-checks-title">
      <h2 id="proc-checks-title" className="proc-sectlabel">
        Check each one <span>· {done} of {sorted.length}</span>
      </h2>
      <div role="group" aria-labelledby="proc-checks-title" className="list">
        {sorted.map((c) => {
          const on = checked.includes(c.checkID);
          return (
            <button
              key={c.checkID}
              type="button"
              role="checkbox"
              aria-checked={on}
              className="proc-check"
              onClick={() => onToggle(c.checkID)}
              disabled={disabled}
            >
              <span className="glyph" aria-hidden="true">
                {on ? <IconSquareCheckFilled size={28} /> : <IconSquare size={28} />}
              </span>
              <span className="t">{c.text}</span>
            </button>
          );
        })}
      </div>
    </section>
  );
}
